const dealerSupportBrandList = [
  { /* ID = 39 */
    name: 'AGI',
    brandIds: [
      'AGAUG',
      'AGFAN',
      'AGSER',
      'AGSOL',
      'EZEED',
      'FANSA-AGI01-AIRLA',
      'FANSA-AGI01-GGARD',
      'FANSC-AGI01-AIRLA',
      'FANHS-AGI01-GGARD',
      'FANLS-AGI01-GGARD',
      'HEATR-AGI01-AIRLA',
      'HEATR-AGI01-GGARD',
      'PRTBA-AGI01-WESTF',
      'GRVAC-AGI01-REM01',
      'POSTP-AGI01-WHERT'
    ]
  },
  { /* ID = 2 */
    name: 'Batco',
    brandIds: [
      'BATCO',
      'PRTBC-AGI01-BATCO',
      'PRTBC-BATCO-BATCO',
      'PRTBC-HUTCH-BATCO',
      'PRTBC-WESTF-BATCO'
    ]
  },
  { /* ID = 3 */
    name: 'Brownie',
    brandIds: [
      'BROWN',
      'CATWA-BROWN-BROWN',
      'TOWER-BROWN-BROWN'
    ]
  },
  { /* ID = 7 */
    name: 'Grain Guard',
    brandIds: [
      'GGFAN',
      'GGROC',
      'AERRO-GGARD-GGARD',
      'FANHS-GGARD-GGARD',
      'FANLS-GGARD-GGARD',
      'FANSA-GGARD-GGARD',
      'HEATR-GGARD-GGARD',
      'ROOFE-GGARD-GGARD'
    ]
  },
  { /* ID = ? */
    name: 'Grain Maxx',
    brandIds: [
      'GRNMX'
    ]
  },
  { /* ID = 8 */
    name: 'GTS',
    brandIds: [
      'GTS01'
    ]
  },
  { /* ID = 11 */
    name: 'Hutchinson',
    brandIds: [
      'HTHCX',
      'HTAUG',
      'HTBCV',
      'HTGRL',
      'HMAUG',
      'PRCCV-HUTCH-HUTCH',
      'PRTBA-HUTCH-HUTCH',
      'PRTBA-HUTCH-WESTF',
      'PRTBA-HUTCH-WHERT'
    ]
  },
  { /* ID = 15 */
    name: 'Keho',
    brandIds: [
      'KEHON',
      'FANHS-KEHON-GGARD',
      'FANLS-KEHON-GGARD',
      'FANSA-KEHON-GGARD',
      'HEATR-KEHON-GGARD'
    ]
  },
  { /* ID = 16 */
    name: 'Mayrath',
    brandIds: [
      'MRAUG',
      'PRTBA-MARAT-WESTF',
      'PRTBA-MARAT-WHERT'
    ]
  },
  { /* ID = 17 */
    name: 'MFS',
    brandIds: [
      'MFS01',
      'ACCES-MFS01-MFS01',
      'AERFL-MFS01-MFS01',
      'BFLBB-MFS01-MFS01',
      'BHBTB-MFS01-MFS01',
      'BINDR-MFS01-MFSEZ',
      'CUSTM-MFS01-CUSTM',
      'WATTA-MFS01-GTS01'
    ]
  },
  { /* ID = 20 */
    name: 'NECO',
    brandIds: [
      'NECO1',
      'MFLDR-NECO1-NECO1',
      'STIRM-NECO1-NECO1'
    ]
  },
  { /* ID = 23 */
    name: 'REM',
    brandIds: [
      'REM01',
      'GRVAC-REM01-REM01'
    ]
  },
  { /* ID = 26 */
    name: 'STORM',
    brandIds: [
      'STORM',
      'SEEDT-STORM-STORM'
    ]
  },
  { /* ID = ? */ name:
    'SURETRACK',
    brandIds: [
      'SRTRK'
    ]
  },
  { /* ID = 28 */
    name: 'Twister',
    brandIds: [
      'TWIST',
      'ACCES-TWIST-WSTEL',
      'BFLBB-TWIST-WSTEL',
      'BHBTB-TWIST-WSTEL'
    ]
  },
  { /* ID = 31 */
    name: 'Westeel',
    brandIds: [
      'WSBUN',
      'WSCON',
      'WSESD',
      'WSFAN',
      'WSGLV',
      'WSLQD',
      'WSSWL',
      'ACCES-WSTEL-WSTEL',
      'AERFL-WSTEL-WSTEL',
      'BFLBB-WSTEL-WSTEL',
      'BHBTB-WSTEL-WSTEL',
      'BINDR-WSTEL-WSESD',
      'CATWA-WSTEL-WSTEL',
      'LFUEL-WSTEL-WSTEL',
      'SFUEL-WSTEL-WSTEL',
      'WATTA-WSTEL-WSTEL',
      'WHOBN-WSTEL-WSTEL',
      'WHOPP-WSTEL-WSTEL'
    ]
  },
  { /* ID = 32 */
    name: 'Westfield',
    brandIds: [
      'WESTF',
      'WFWCX',
      'PRCCV-WESTF-HUTCH',
      'PRTBA-WESTF-WESTF'
    ]
  },
  { /* ID = 37, 38 */
    name: 'Wheatheart',
    brandIds: [
      'WHAUG',
      'WHPPD',
      'PRTBA-AGI01-WHERT',
      'POSTP-WHERT-WHERT'
    ]
  },
  { /* ID = 35 */
    name: 'York',
    brandIds: [
      'YORK1',
      'BUCKE-YORK1-YORK1',
      'CHCON-YORK1-YORK1'
    ]
  }
];

const filterAuthorizedBrands = (userBrands, isAGIUser) => {
  if (isAGIUser) {
    return dealerSupportBrandList;
  }

  const brandSet = new Set();
  
  userBrands.forEach(id => {
    const brand = dealerSupportBrandList.find(ref => ref.brandIds.includes(id));
    if (brand) brandSet.add(brand);
  });

  if (brandSet.size === 0) {
    return dealerSupportBrandList;
  }

  return Array.from(brandSet);
};

const filterAllBrandByAuthBrands = (allBrands, authBrands) =>
  allBrands.filter(brand => {
    return authBrands.find(b => b.name === brand.Name);
  });

const hasAuthorizedPartBrands = function(partsBrands) {
  return !(Array.isArray(partsBrands) && partsBrands.length > 0);
}

export {
  dealerSupportBrandList,
  filterAuthorizedBrands,
  filterAllBrandByAuthBrands,
  hasAuthorizedPartBrands
};



// WEBPACK FOOTER //
// ./src/utils/BrandHelper.js